import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";


@Injectable()
export class LogService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = '/log';

    async get(queryString){
        return  await this.httpClient.get(`${this.endPoint}?${queryString}`);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/log.service.ts